import type { UserGroupCouponRecord } from '@navio/nsdk';

export type WalletCouponsByUsageKind = {
  fixedBenefits: UserGroupCouponRecord[];
  discountCoupons: UserGroupCouponRecord[];
};

export type DiscountCouponsByAvailability = {
  active: UserGroupCouponRecord[];
  used: UserGroupCouponRecord[];
};

const isFixedBenefitCoupon = (coupon: UserGroupCouponRecord): boolean => coupon.maxUses == null;

const isDiscountCoupon = (coupon: UserGroupCouponRecord): boolean => !isFixedBenefitCoupon(coupon);

export const isUsedDiscountCoupon = (coupon: UserGroupCouponRecord): boolean => {
  if (!isDiscountCoupon(coupon)) {
    return false;
  }
  if (coupon.usesRemaining === 0) {
    return true;
  }
  const spentUses: number = coupon.spentUses ?? 0;
  const maxUses: number = coupon.maxUses ?? 0;
  return maxUses > 0 && spentUses >= maxUses;
};

export const splitDiscountCouponsByAvailability = (coupons: UserGroupCouponRecord[]): DiscountCouponsByAvailability => {
  const active: UserGroupCouponRecord[] = [];
  const used: UserGroupCouponRecord[] = [];

  for (const coupon of coupons) {
    if (!isDiscountCoupon(coupon)) {
      continue;
    }
    if (isUsedDiscountCoupon(coupon)) {
      used.push(coupon);
      continue;
    }
    active.push(coupon);
  }

  return { active, used };
};

export const splitWalletCouponsByUsageKind = (coupons: UserGroupCouponRecord[]): WalletCouponsByUsageKind => {
  const fixedBenefits: UserGroupCouponRecord[] = [];
  const discountCoupons: UserGroupCouponRecord[] = [];

  for (const coupon of coupons) {
    if (isFixedBenefitCoupon(coupon)) {
      fixedBenefits.push(coupon);
      continue;
    }
    discountCoupons.push(coupon);
  }

  return { fixedBenefits, discountCoupons };
};
